// ** Logo
import themeConfig from '@configs/themeConfig'
import React from "react"

const SpinnerComponent = () => {
  return (
    <div className='d-flex justify-content-center align-items-center vh-100'>
      <img src={themeConfig.app.appLogoImage} alt='logo' />
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
